import Modal from "/WebInterface/new-ui/modules/modal.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export const initRevisions = (selected) => {
  const theme = _$("html").attr("data-theme");
  const lang = _$("html").attr("lang");
  const hrefPath = selected.href_path;

  const revisionsUrl = `/WebInterface/new-ui/revisions/index.html?theme=${encodeURIComponent(
    theme || ""
  )}&lang=${encodeURIComponent(lang || "")}&path=${encodeURIComponent(
    hrefPath || ""
  )}`;

  new Modal({
    title: "revisions",
    body: `<div class="w-full h-full"><iframe frameborder="0" class="w-full h-full" name="revisionsIframe" id="revisionsIframe" src="${utils.escapeHtmlAttr(
      revisionsUrl
    )}" hspace="0" allowtransparency="false"></iframe></div>`,
    uniqueId: "revisions-modal",
    extraClasses: ["revisions-modal"],
    hasResizeOption: true,
    movable: true,
    backdrop: false,
    animate: false,
    hasFooter: false,
    minWidth: "1200px",
    minHeight: "600px",
    buttons: [],
    headerButtons: [
      {
        label: `<i class="icon-link text-accentMain mr-2"></i><span data-i18n-key="openInASeparateWindow">${t(
          "openInASeparateWindow"
        )}</span>`,
        close: false,
        classes: ["mr-3", "is-bg-none", "p-0"],
        onClick: () => {
          open(revisionsUrl);
        },
      },
    ],
    onAfterShow: () => {
      const overrideFontFamily = utils.getUserCustomizationValue(
        "fontFace",
        true
      );

      const iframe = _$("#revisionsIframe").el();
      iframe.contentWindow.postMessage({
        key: "overrideFontFamily",
        value:
          overrideFontFamily ||
          'BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
      });
    },
  });
};
